import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { applyInitialTheme } from './lib/theme';
import './styles.css';

// Before first paint, so a light-mode user doesn't get a dark flash.
applyInitialTheme();

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root not found');

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
